import React, { useState, useEffect } from 'react';
import { shareHandle } from './share-handle';
import { ShareListType } from 'const/share-type';
import { buriedPoint } from 'utils/log-buried-point';
import shopApi from 'api/shop';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { Style } from './style';

// 不知道为什么会存在两个， 暂时没时间排查，先放着
export const ShareButtons = (props) => {
  const intl = useIntl();
  const SHARE_STYLE = {
    rectangle: 'rectangle',
    circular: 'circular',
  };
  // handleBuriedPoint 自定义分享埋点
  const {
    customClass,
    postInfo = {},
    socialShareData = {},
    shareThirdUrl: linkUrl = '',
    copyUrl,
    showWeChat = true,
    handleBuriedPoint,
  } = props || {};
  const [shareList, setShareList] = useState([]);
  const {
    share_button_shape: shareButtonShape = SHARE_STYLE.circular,
    share_button_custom: shareButtonCustom,
    share_button_color: shareButtonColor,
    show_share_button: showShareButton = true,
  } = socialShareData;

  const buriedPointShare = (method) => {
    buriedPoint('share', { method });
  };

  const onShareGoods = (shareType) => {
    const shareThirdUrl = `${window.location.origin}/${linkUrl}`;
    handleBuriedPoint ? handleBuriedPoint() : buriedPointShare(shareType);
    shareHandle({ intl, shareType, shareThirdUrl, copyUrl, postInfo });
  };

  useEffect(() => {
    shopApi.getShopSpreadBasicInfo({ kdtId: window?.global_data?.kdtId }).then((res) => {
      let { shopSpreadChannels } = res;
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        // 现在手机端才有messenger，pc端需要appid账号
        shopSpreadChannels = shopSpreadChannels.filter((item) => item.type !== ShareListType.Messenger);
      }
      setShareList(shopSpreadChannels);
    });
  }, []);
  const filterShareList = showWeChat ? shareList : shareList.filter((item) => item.type !== ShareListType.WeChat);
  return showShareButton && filterShareList.length > 0 ? (
    <Style>
      <div className={cn('share-buttons-container skiptranslate', customClass)}>
        {shareButtonShape === SHARE_STYLE.rectangle &&
          filterShareList.map((item) => {
            return (
              <span
                className='featured-products-share-item'
                onClick={() => {
                  onShareGoods(item.type);
                }}
                key={item.type}
              >
                <svg
                  className={cn(`${item.type}-icon`, 'featured-products-share-icon')}
                  aria-hidden='true'
                  style={{ fill: shareButtonCustom ? shareButtonColor : item.defaultColor }}
                >
                  <use xlinkHref={item.icon} />
                </svg>
                {intl.formatMessage({ id: item.name })}
              </span>
            );
          })}
        {shareButtonShape === SHARE_STYLE.circular &&
          filterShareList.map((item) => {
            return (
              <span
                className='circular-icon-item'
                key={item.type}
                onClick={() => {
                  onShareGoods(item.type);
                }}
              >
                <svg aria-hidden='true' style={{ fill: shareButtonCustom ? shareButtonColor : item.defaultColor }}>
                  <use xlinkHref={item.icon} />
                </svg>
              </span>
            );
          })}
      </div>
    </Style>
  ) : null;
};
